export default __webpack_public_path__ + "static/media/create_moodbord_bg.378e613e.png";